import React, { useState, useEffect, useRef } from "react";
import { useLiffProfile } from "../../context/LiffProfileContext";
import { useTranslation } from "react-i18next";
import ErrorModal from "../modals/ErrorModal";
import { TERMS_AND_CONDITIONS } from "../../locales/terms-conditions";

const TermRegister = ({ show, onAccept, onClose, payload }) => {
  const { authToken, userId } = useLiffProfile();
  const { t, i18n } = useTranslation();
  const [termContent, setTermContent] = useState("");
  const [canAccept, setCanAccept] = useState(false);
  const [error, setError] = useState(null);
  const scrollRef = useRef(null);

  useEffect(() => {
    const lang = i18n.language.toLowerCase();
    if (TERMS_AND_CONDITIONS[lang]) {
      setTermContent(TERMS_AND_CONDITIONS[lang]);
    } else {
      setError(t("Terms and conditions not available in this language."));
    }
  }, [i18n.language]);

  useEffect(() => {
    // reset scroll + button state เมื่อ popup เปิดใหม่
    if (show) {
      setCanAccept(false);
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
    }
  }, [show]);

  const handleScroll = () => {
    const el = scrollRef.current;
    if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
      setCanAccept(true);
    }
  };

  if (!show) return null;
  if (error) return <ErrorModal error={error} onClose={onClose} />;
  if (!termContent) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-lg relative">
        <button
          className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-xl"
          onClick={onClose}
        >
          &times;
        </button>
        <h3 className="text-xl font-semibold mb-4">{t("terms_text_2")}</h3>

        {/* Scrollable Terms */}
        <div
          ref={scrollRef}
          onScroll={handleScroll}
          className="overflow-y-auto max-h-[50vh] mb-4 text-base text-left"
        >
          <div
            className="whitespace-pre-wrap"
            dangerouslySetInnerHTML={{ __html: termContent }}
          />
        </div>

        {/* Consent Button */}
        <div className="flex justify-center">
          <button
            className={`px-6 py-2 rounded-full text-white transition-all duration-300 ${
              canAccept ? "bg-primary" : "bg-gray-400 cursor-not-allowed"
            }`}
            onClick={() => canAccept && onAccept(1)}
            disabled={!canAccept}
          >
            {t("consent")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermRegister;
